import { createContext } from 'react';

type VotersContextData = {
	isMeatBallMenuOption: boolean;
};

const initialValue: VotersContextData = {
	isMeatBallMenuOption: false,
};

export const VotersContext = createContext(initialValue);
